const API_BASE_URL = process.env.REACT_APP_API_URL ?? '';

export async function autoSaveDocument(mappedResult, appInfo, session, setSaveStates) {
  const docType = mappedResult.docType;
  setSaveStates(prev => ({ ...prev, [docType]: 'saving' }));
  try {
    const res = await fetch(`${API_BASE_URL}/api/documents/save`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${session?.access_token}`,
      },
      body: JSON.stringify({
        type: docType,
        content: mappedResult.resumeText,
        scores: {
          ...mappedResult.scores,
          ...(mappedResult.originalScores ? { original_scores: mappedResult.originalScores } : {}),
        },
        job_title: appInfo.targetJobTitle || '',
        company: appInfo.company || '',
      }),
    });
    if (res.ok) {
      setSaveStates(prev => ({ ...prev, [docType]: 'saved' }));
      setTimeout(() => {
        setSaveStates(prev => { const n = { ...prev }; delete n[docType]; return n; });
      }, 4000);
    } else {
      setSaveStates(prev => ({ ...prev, [docType]: 'error' }));
    }
  } catch {
    setSaveStates(prev => ({ ...prev, [docType]: 'error' }));
  }
}
